export default "__VITE_ASSET__BvGo3r41__"